<div class="items-list my-2">
    <div class="tile" *ngFor="let item of items">
        <input type="checkbox" [(ngModel)]="item.isSelected" (ngModelChange)="select($event,item)" />
        <label>
      <img [src]="item.imageURL" alt="">
      <p>{{ item.label | translate }}</p>
    </label>
    </div>
</div>